import {
    onAdClosed,
    onAdFallback,
    onAdLoaded,
    onAdShown,
    onAdWaitTimeout,
    onRequest,
    onAdsSuccess,
    onNoAds,
    onScriptError,
    onLoadError,
    onLoadSuccess,
    type IBannerResponse
} from "./BannerPlaceListeners";
import type {BannerRequestId} from "../transport/BannerRequestId";

let instance: BannerPlaceListenersProxy | null = null;

export class BannerPlaceListenersProxy {

    static getInstance() {
        if (instance === null) {
            instance = new BannerPlaceListenersProxy();
        }
        return instance;
    }

    getResponseData(reqId: BannerRequestId): IBannerResponse {
        return {
            transport: reqId.transport,
            place: reqId.bannerPlace,
            slot: reqId.slot,
            el: reqId.container,
            result: reqId.getResult()
        };
    }

    onRequest(reqId: BannerRequestId) {
        onRequest(this.getResponseData(reqId));
    }

    onAdsSuccess(reqId: BannerRequestId) {
        onAdsSuccess(this.getResponseData(reqId));
    }

    onNoAds(reqId: BannerRequestId) {
        onNoAds(this.getResponseData(reqId));
    }

    onScriptError(reqId: BannerRequestId) {
        onScriptError(this.getResponseData(reqId));
    }

    onLoadSuccess(reqId: BannerRequestId) {
        onLoadSuccess(this.getResponseData(reqId));
    }

    onLoadError(reqId: BannerRequestId) {
        onLoadError(this.getResponseData(reqId));
    }

    onAdClosed(reqId: BannerRequestId) {
        onAdClosed(this.getResponseData(reqId));
    }

    onAdFallback(reqId: BannerRequestId) {
        onAdFallback(this.getResponseData(reqId));
    }

    onAdLoaded(reqId: BannerRequestId) {
        onAdLoaded(this.getResponseData(reqId));
    }

    onAdShown(reqId: BannerRequestId) {
        onAdShown(this.getResponseData(reqId));
    }

    onAdWaitTimeout(reqId: BannerRequestId) {
        onAdWaitTimeout(this.getResponseData(reqId));
    }
}
